import AccountExecutionIssuesTab from "./components/AccountExecutionIssuesTab";

export default function TerminalAnomaliesPage() {
  return <AccountExecutionIssuesTab terminalOnly />;
}
